module.exports = __webpack_public_path__ + "img/individual-meter-heat-meter-counter-lg.3eae362f.svg";